export default __webpack_public_path__ + "assets/competition-bg-gold-0b8a4a64f1df918661fb0ba976fb7e87.png";